"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorPickerWidget = exports.isColorInPreset = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var TabStyles_1 = require("../../styles/TabStyles");
var Declarative_1 = require("../../utils/Declarative");
var DomUtil_1 = require("../../utils/DomUtil");
var DropdownButton_1 = require("../Dropdown/DropdownButton");
var ColorGridWidget_1 = require("./ColorGridWidget");
var ColorPickerPresets_1 = require("./ColorPickerPresets");
Object.defineProperty(exports, "isColorInPreset", { enumerable: true, get: function () { return ColorPickerPresets_1.isColorInPreset; } });
var CustomColorInputWidget_1 = require("./CustomColorInputWidget");
function getCustomColorInput(selectedColor, colorsPreset) {
    if (!selectedColor) {
        return '';
    }
    return !ColorPickerPresets_1.isColorInPreset(selectedColor, colorsPreset) ? selectedColor : '';
}
exports.ColorPickerWidget = React.forwardRef(function (props, ref) {
    var dialogId = React.useState(DomUtil_1.generateId())[0];
    var closeFn = React.useRef(null);
    var onColorSelected = function (color) {
        var _a, _b;
        (_a = closeFn.current) === null || _a === void 0 ? void 0 : _a.call(closeFn);
        // eslint-disable-next-line deprecation/deprecation
        (_b = (props.onColorSelected || props.handleColorSelected)) === null || _b === void 0 ? void 0 : _b(color.toLowerCase());
    };
    var selectedColorString = (props.selectedColor || '').toLowerCase();
    var getElementToFocus = props.showCustomColorInput && props.selectedColor && !ColorPickerPresets_1.isColorInPreset(props.selectedColor, props.colorsPreset) &&
        (function (popup) { return popup.querySelector('input'); }) || undefined;
    return React.createElement("div", { style: { display: 'inline-block' }, "data-tb-test-id": Declarative_1.makeTestId(props.testId, 'ColorPicker') },
        React.createElement(DropdownButton_1.DropdownButton, { "aria-controls": dialogId, "aria-haspopup": 'dialog', "data-tb-test-id": Declarative_1.makeTestId(props.testId, 'ColorPickerButton'), disabled: props.disabled, 
            // eslint-disable-next-line deprecation/deprecation
            focusOnClose: props.focusOnClose || props.shouldReturnFocusOnClose, getElementToFocus: getElementToFocus, label: props.label, onOpen: function (doneFn) { return closeFn.current = doneFn; }, popupAlignment: props.popupAlignment, popupContent: React.createElement(ColorGridPopupContent, { colorsPreset: props.colorsPreset, disabled: props.disabled, handleSwatchClicked: onColorSelected, id: dialogId, selectedColor: props.selectedColor, showCustomColorInput: props.showCustomColorInput, testId: props.testId }), ref: ref, 
            // eslint-disable-next-line deprecation/deprecation
            stackingRootId: props.stackingRootId, testId: null, title: props.title, type: DropdownButton_1.DropdownButtonType.Outline, 
            // eslint-disable-next-line deprecation/deprecation
            zIndex: props.zIndex || props.dropdownZIndex },
            React.createElement("div", { "aria-label": selectedColorString, style: {
                    backgroundColor: selectedColorString,
                    boxSizing: 'border-box',
                    display: 'inline-block',
                    height: '50%',
                    width: props.colorLabelWidth || 40,
                } })));
});
exports.ColorPickerWidget.defaultProps = { colorsPreset: ColorGridWidget_1.ColorGridPreset.Dark, focusOnClose: true };
exports.ColorPickerWidget.displayName = 'ColorPickerWidget';
var ColorGridPopupContent = function (props) {
    return React.createElement("div", { "data-tb-test-id": Declarative_1.makeTestId(props.testId, 'ColorGridWrapper'), id: props.id, role: 'dialog', style: { padding: TabStyles_1.TabStyles.Spacing.LargeSpace } },
        React.createElement(ColorGridWidget_1.ColorGridWidget, { colorsPreset: props.colorsPreset, disabled: props.disabled, handleSwatchClicked: props.handleSwatchClicked, selectedColor: (props.selectedColor || '').toLowerCase(), testId: 'colorgrid' }),
        props.showCustomColorInput && React.createElement(React.Fragment, null,
            React.createElement("hr", { style: { marginTop: TabStyles_1.TabStyles.Spacing.LargeSpace } }),
            React.createElement(CustomColorInputWidget_1.CustomColorInput, { color: getCustomColorInput(props.selectedColor, props.colorsPreset), onColorSelected: props.handleSwatchClicked, testId: props.testId })));
};
ColorGridPopupContent.displayName = 'ColorGridPopupContent';
//# sourceMappingURL=ColorPickerWidget.js.map